// @flow
import waitForAnalytics from './wait'

export default function prospect(action: 'created' | 'applied') {
  waitForAnalytics(() => window.analytics.track(`Prospect ${action}`))
}
